import { Loader2, FileText, Download } from "lucide-react";
import toast from "react-hot-toast";
import driverApi from "../../utils/driverApi";
import { useDriverDocuments } from "../../hooks/useDriverPortal";

const DOC_LABELS = { rc: "RC", insurance: "Insurance", permit: "Permit", puc: "PUC", fitness: "Fitness Certificate" };

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

async function openOwn(which) {
  try {
    const { data } = await driverApi.get(`/api/driver/documents/own/${which}`);
    window.open(data.url, "_blank", "noopener,noreferrer");
  } catch (err) {
    toast.error(err.message || "Could not open document");
  }
}
async function openVehicleDoc(id) {
  try {
    const { data } = await driverApi.get(`/api/driver/documents/vehicle/${id}`);
    window.open(data.url, "_blank", "noopener,noreferrer");
  } catch (err) {
    toast.error(err.message || "Could not open document");
  }
}

function DocRow({ label, sub, onClick }) {
  return (
    <button onClick={onClick} style={{
      display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%",
      background: "none", border: "none", borderTop: "1px solid #F3F4F6", padding: "12px 0", cursor: "pointer", textAlign: "left",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <FileText size={15} color="#4F46E5" />
        <div>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: "#111827" }}>{label}</div>
          {sub && <div style={{ fontSize: 11.5, color: "#9CA3AF" }}>{sub}</div>}
        </div>
      </div>
      <Download size={14} color="#9CA3AF" />
    </button>
  );
}

export default function DriverDocuments() {
  const { data, loading } = useDriverDocuments();

  if (loading) {
    return (
      <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader2 size={18} style={{ animation: "spin 1s linear infinite", color: "#9CA3AF" }} />
      </main>
    );
  }

  return (
    <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB" }}>
      <div style={{ maxWidth: 700, margin: "0 auto", padding: "28px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", marginBottom: 2 }}>Documents</div>
        <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>View and download only</div>

        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "16px 18px", marginBottom: 14 }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#111827", marginBottom: 4 }}>My Documents</div>
          {data?.ownDocuments?.length ? data.ownDocuments.map(d => (
            <DocRow key={d.key} label={d.label} onClick={() => openOwn(d.key)} />
          )) : <div style={{ fontSize: 13, color: "#9CA3AF", padding: "10px 0" }}>No personal documents on file.</div>}
        </div>

        <div style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "16px 18px" }}>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#111827", marginBottom: 4 }}>Vehicle Documents</div>
          {data?.vehicleDocuments?.length ? data.vehicleDocuments.map(d => (
            <DocRow key={d.id} label={DOC_LABELS[d.docType] || d.docType} sub={`Expires ${fmtDate(d.expiryDate)}`} onClick={() => openVehicleDoc(d.id)} />
          )) : <div style={{ fontSize: 13, color: "#9CA3AF", padding: "10px 0" }}>No vehicle documents on file.</div>}
        </div>
      </div>
    </main>
  );
}
